// extracted by mini-css-extract-plugin
module.exports = {"tabelAlign":"share_tabelAlign__1JpGY","tableWrapper":"share_tableWrapper__3-M4w","mainWrapper":"share_mainWrapper__2OnLj"};